export default {
  zh: {
    invtieText: '邀请',
    hanleSuc: '邀请成功',
    searchPolad: '搜索昵称或ID',
    hanleErr: '邀请失败，请稍后重试',
    searchText: '搜索'
  },
  ar: {
    invtieText: 'يدعو',
    hanleSuc: 'تمت الدعوة بنجاح',
    searchPolad: 'البحث عن اللقب أو الهوية',
    hanleErr: 'فشلت الدعوة، يرجى المحاولة مرة أخرى لاحقًا',
    searchText: 'يبحث'
  },
  tr: {
    invtieText: 'Davet Et',
    hanleSuc: 'Başarıyla Davet Edildi',
    searchPolad: 'Takma Ad veya Kimliğe Göre Arayın',
    hanleErr: 'Davet başarısız oldu, lütfen daha sonra tekrar deneyin',
    searchText: 'Ara'
  },
  en: {
    invtieText: 'Invite',
    hanleSuc: 'Invite successfully',
    searchPolad: 'Search by nickname or ID',
    hanleErr: 'Invite failed,please try again later',
    searchText: 'Search'
  },
  pt: {
    invtieText: 'Convidar',
    hanleSuc: 'Convite enviado com sucesso',
    searchPolad: 'Buscar por apelido ou ID',
    hanleErr: 'Convite falhou, por favor tente novamente mais tarde',
    searchText: 'Buscar'
  },
  id: {
    invtieText: 'Undang',
    hanleSuc: 'Undangan berhasil',
    searchPolad: 'Cari berdasarkan nama panggilan atau ID',
    hanleErr: 'Undangan gagal, silakan coba lagi nanti',
    searchText: 'Cari'
  },
  uz: {
    invtieText: 'Taklif etish',
    hanleSuc: 'Taklif muvaffaqiyatli',
    searchPolad: "Lid yoki ID bo'yicha qidirish",
    hanleErr: "Taklif muvaffaqiyatsiz, iltimos, keyinroq qayta urinib ko'ring",
    searchText: 'Qidirish'
  },
  ru: {
    invtieText: 'Пригласить',
    hanleSuc: 'Приглашение успешно',
    searchPolad: 'Поиск по нику или ID',
    hanleErr: 'Приглашение не удалось, пожалуйста, попробуйте позже',
    searchText: 'Поиск'
  },

  fa: {
    invtieText: 'دعوت',
    hanleSuc: 'دعوت با موفقیت انجام شد',
    searchPolad: 'جستجو بر اساس نام کاربری یا شناسه',
    hanleErr: 'دعوت ناموفق بود، لطفا بعدا دوباره تلاش کنید',
    searchText: 'جستجو'
  },
  ur: {
    invtieText: 'دعوت دیں',
    hanleSuc: 'دعوت کامیاب رہی',
    searchPolad: 'عرفیت یا آئی ڈی سے تلاش کریں',
    hanleErr: 'دعوت ناکام ہوئی، براہ کرم بعد میں کوشش کریں',
    searchText: 'تلاش کریں'
  }
}



// WEBPACK FOOTER //
// src/pages/app/invitation/lang.js